import { AuthenticationContext } from '@src/authentication/AuthenticationContext';
import { useContext } from 'react';

export const useAuthenticatedUser = () => {
  const { user } = useContext(AuthenticationContext);

  if (!user) {
    throw new Error('User need to be authenticated in this context');
  }

  return { user };
};
